import update from "immutability-helper";
import {
  SET_NOTIFICATION,
  RESET_NOTIFICATION,
  getNotificationClassnameFromCode,
  getNotificationIconFromCode,
} from "./index";

export const initialState = null;

const setNotificationHandler = (state, action) => {
  return update(state, {
    $set: {
      className: getNotificationClassnameFromCode(action.code),
      message: action.message && action.message !== undefined ? action.message : null,
      description: action.description && action.description !== undefined ? action.description : null,
      icon: getNotificationIconFromCode(action.code),
      duration: action.duration ? action.duration : 0,
    },
  });
};

const resetNotificationHandler = (state, action) => {
  return update(state, { $set: null });
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return setNotificationHandler(state, action);
    case RESET_NOTIFICATION:
      return resetNotificationHandler(state, action);
    default:
      return state;
  }
};
